import { createAction } from 'typesafe-actions';

export const systemEventSetupOrganisationOpened = createAction(
  'systemEventSetupOrganisationOpened',
)();
export const systemEventSetupOrganisationNotOpened = createAction(
  'systemEventSetupOrganisationNotOpened',
)();
